import { z } from "zod";

const SampleNameSchema = z.object({
  label: z.string(),
  value: z.string(),
})

const getTranslatedStr = (path: string): string => {
    const translatn = 'qiagenManager.errors'
    return `${translatn}.${path}`
  }

export const schemaHelpers = {
  requiredDate: z.coerce.string().transform((dateString, ctx) => {
      if (!dateString || dateString == 'null') {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: getTranslatedStr('required'),
        })
      }
      const date = new Date(dateString)
      if (!z.date().safeParse(date).success) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_date,
        })
      }
      return date
    }),
  requiredSelect: z.array(SampleNameSchema).nonempty({ message: getTranslatedStr('required') }),
}